import React from "react";
import { Row, Col, FloatingLabel, FormControl, Form } from 'react-bootstrap';
import Validator from "../../../services/Validator";
import { useAuthState } from "../../../context/AuthContext";
import EnergoTooltip from "../../shared/Tooltip";



/**
 * 
 * @param {param} data object of data passed from main container
 * @param {param} setData setter for object data
 * @param {param} errors object of errors passed from main container
 * @param {param} setErrors setter for object errors
 * 
 * @returns fields 
 */
const RegisterStage = ({ data, setData, errors, setErrors }) => {

    const { tooltips, tooltipsTrigger} = useAuthState()
    const VALIDATOR = new Validator();
    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() + 14);

    const greaterOrEqualDate = (date, dateLimit) => {
        // Create new Date objects without time for the input date
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      
        // Create new Date object without time for the dateLimit
        const newDateLimit = new Date(dateLimit.getFullYear(), dateLimit.getMonth(), dateLimit.getDate());
      
        // Compare the dates
        if (newDate.getTime() >= newDateLimit.getTime()) {
          return true
        } else {
          return false;
        }
      }
    const greaterDate = (date, dateLimit) => {
        // Create new Date objects without time for the input date
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      
        // Create new Date object without time for the dateLimit
        const newDateLimit = new Date(dateLimit.getFullYear(), dateLimit.getMonth(), dateLimit.getDate());
      
        // Compare the dates
        if (newDate.getTime() > newDateLimit.getTime()) {
          return true
        } else {
          return false;
        }
      }


    // handler for iban field
    const ibanHandler = (event) => {
        const inputValue = event.target.value;
    
        // replace any characters that aren't digit or letter
        const formattedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    
        // group characters in 4 block
        const restFormatted = formattedValue.substring(0).replace(/(.{4})(?!$)/g, '$1 ');
    
        // set new value with uppercase
        setData((prev) => ({...prev, iban: restFormatted.toUpperCase()}));
    };
    
    
    return (
        <>
            <Row className="align-items-center">
                <Col xl="4">
                    <FloatingLabel label="Anlage anmelden am">
                        <FormControl
                            value={data.registerDate}
                            onChange={e => { setData((prev) => ({ ...prev, registerDate: e.target.value })); setErrors({}) }}
                            type="date"
                            placeholder="Anlagen anmelden am"
                            isValid={data.registerDate !== ""}
                            isInvalid={errors.registerDate}
                        />
                    </FloatingLabel>
                </Col>
                { greaterDate(new Date, new Date(data.registerDate))?
                    <Col xl="5">
                        <p>
                            Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung 
                            wird in Abstimmung mit dem Energielieferanten am frühest 
                            möglichen Zeitpunkt durchgeführt.
                        </p>
                    </Col>
                :null}
                <Col xl="3" hidden={data.anlageUse === "Allgemeine Liegenschaftsteile"}>
                    <Form.Check
                        type="checkbox"
                        label="Als Leerstand anmelden"
                        defaultChecked={data.anlageUse !== "Allgemeine Liegenschaftsteile"}
                        value={data.asLeerstand}
                        onChange={e => setData((prev) => ({ ...prev, asLeerstand: e.target.checked }))}
                    />
                </Col>
            </Row>
            <Row className="mt-4" >
                <Col xl="6">
                    <FloatingLabel label="Zählerstand">
                        <FormControl
                            value={data.zaehlerstand1}
                            onChange={e => { setData((prev) => ({ ...prev, zaehlerstand1: e.target.value })); setErrors({}) }}
                            isValid={data.zaehlerstand1 !== "" && VALIDATOR.IsZaehlerstand(data.zaehlerstand1)}
                            isInvalid={errors.zaehlerstand1}
                            placeholder="Zählerstand"
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="6" hidden={data.secondZaehler === false}>
                    <FloatingLabel label="Zweiter Zählerstand">
                        <FormControl
                            value={data.zaehlerstand2}
                            onChange={e => { setData((prev) => ({ ...prev, zaehlerstand2: e.target.value })); setErrors({}) }}
                            isValid={data.zaehlerstand2 !== "" && VALIDATOR.IsZaehlerstand(data.zaehlerstand2)}
                            isInvalid={errors.zaehlerstand2}
                            placeholder="Zweiter Zählerstand"
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4" hidden={data.smartmeter === true || !greaterOrEqualDate(new Date(data.registerDate), dateLimit) || data.registerDate === ""}>
                <Col xs="12">
                    <p>Anmeldung mehr als 14 Tage in der Zukunft! Bitte geben Sie die Zählerstände der Anlage rechtzeitig zum Anmeldedatum bei ENERGO bekannt.</p>
                </Col>
            </Row>
            <Row className="mt-4 align-items-center">
                <Col xl="6" style={{display: "flex"}}>
                    <Form.Check
                        defaultChecked={data.useMtu}
                        onChange={e => setData((prev) => ({...prev, useMtu: e.target.checked}))}
                        value={data.useMtu}
                        type="checkbox"
                        label="Abrechnung über Messtechnikunternehmen"
                        style={{marginRight: 10}}
                    />
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 107) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 107).help_text} position="right" /> : null
                    :null}
                </Col>
                <Col xl="6" hidden={data.useMtu === false}>
                    <FloatingLabel label="Name des Messtechnikunternehmens">
                        <FormControl
                            onChange={e => { setData((prev) => ({...prev, mtuName: e.target.value})); setErrors({}) }}
                            value={data.mtuName}
                            placeholder="Name des Messtechnikunternehmens"
                            isValid={data.useMtu && data.mtuName !== ""}
                            isInvalid={errors.mtuName}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xl="6" hidden={data.useMtu === false} style={{display: "flex"}}>
                    <Form.Check 
                        defaultChecked={data.mtuDirect}
                        value={data.mtuDirect} 
                        onChange={e => setData((prev) => ({...prev, mtuDirect: e.target.checked}))} 
                        type="checkbox" 
                        label="Direktverrechnung" 
                        style={{marginRight: 10}}
                    />
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 108) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 108).help_text} position="right" /> : null
                    :null}
                </Col>
                <Col xl="6" hidden={data.mtuDirect === false || data.useMtu === false}>
                    <Form.Check
                        type="checkbox"
                        defaultChecked={data.mtuPaysOverTransfer}
                        onChange={e => setData((prev) => ({...prev, mtuPaysOverTransfer: e.target.checked}))}
                        label="Messtechnikunternehmen zahlt per Überweisung"
                    />
                </Col>
            </Row>
            <Row className="mt-4" hidden={data.mtuDirect === false || data.useMtu === false}>
                <Col xl="6">
                    <FloatingLabel label="Kontoinhaber">
                        <FormControl
                            value={data.cardHolder}
                            onChange={e => {setData((prev) => ({...prev, cardHolder: e.target.value})); setErrors({}) }}
                            placeholder="Kontoinhaber"
                            isValid={data.cardHolder !== ""}
                            isInvalid={errors.cardHolder}
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="6">
                    <FloatingLabel label="IBAN">
                        <FormControl
                            value={data.iban}
                            onChange={e => {ibanHandler(e); setErrors({}) }}
                            placeholder="IBAN"
                            isValid={VALIDATOR.ibanValid(data.iban.replace(/\s+/g, ''))}
                            isInvalid={errors.iban}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
        </>
    )
}
export default RegisterStage;